import { func, number, oneOfType, string } from "prop-types";
import { useEffect, useRef, useState } from "react";

import classes from "./CellInput.module.scss";

const CellInput = ({
  onBlur,
  onSubmit,
  onValueChange,
  placeholder,
  sanitizeUserInput = (v) => v,
  ...props
}) => {
  const ref = useRef();
  const [value, setValue] = useState(props.value || "");
  const [height, setHeight] = useState("auto");

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    const inputLength = props.value?.length;
    el.setSelectionRange(inputLength, inputLength);
    el.focus({ preventScroll: true });
    setHeight(el.scrollHeight);
  }, []);

  const onChange = (e) => {
    const newValue = sanitizeUserInput(e.target.value);
    setValue(newValue);
    setHeight(e.target.scrollHeight);
    onValueChange?.(newValue);
  };

  const onKeyDown = (e) => {
    const { key, shiftKey } = e;

    if (key === "Enter" && !shiftKey) {
      e.preventDefault();
      onSubmit(value);
    }
  };

  return (
    <textarea
      className={classes["cell_input"]}
      data-testid="cell-text-input"
      onBlur={() => onBlur(value)}
      onChange={onChange}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      ref={ref}
      rows={1}
      style={{ height }}
      value={value}
    />
  );
};

CellInput.propTypes = {
  onBlur: func,
  onSubmit: func,
  onValueChange: func,
  placeholder: string,
  sanitizeUserInput: func,
  value: oneOfType([string, number]),
};

export default CellInput;
